const InLineLoadingSpinner = () => {
    return (
        <div className="loadingSpinnerComponent">
            <div id="loading-bar-spinner" className="spinner">
                <div className="spinner-icon"></div>
            </div>
        </div>
    )
};

export default InLineLoadingSpinner